import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import './GMATCalculator.css';
import { operationCyphers, buttonCyphers, OperatorExpression } from '../../common/constant';

class GMATCalculator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      calcMemory: '',
      calcInput: '',
      answer: '',
      error: '',
      op: '',
      isExpressionValidated: false,
    };
  }

  handleAC = () => {
    this.setState({
      calcInput: '',
      calcMemory: '',
      answer: '',
    });
  };

  handleCE = () => {
    this.setState({
      calcInput: '',
    });
  };

  handleNumberClick = (event, value) => {
    switch (true) {
      case this.state.answer !== '':
        this.setState({
          answer: '',
          calcInput: value,
          calcMemory: value,
        });
        break;

      case operationCyphers.includes(this.state.calcInput):
        this.setState({
          calcInput: value,
          calcMemory: this.state.calcMemory + value,
        });
        break;
      case buttonCyphers.includes(value):
        if (this.state.isExpressionValidated) {
          this.setState({
            calcInput: `${value}`,
            calcMemory: `${value}`,
            isExpressionValidated: false,
          });
          return;
        }
        this.setState({
          calcInput: `${this.state.calcInput}${value}`,
          calcMemory: `${this.state.calcMemory}${value}`,
        });
        break;
      default:
    }
  };

  handleOperator = (operator) => {
    const calcm = this.state.calcInput[this.state.calcInput.length - 1];
    if (
      this.state.calcMemory.length === 0 &&
      (operator === '+' ||
        operator === 'x' ||
        operator === '/' ||
        operator === '-' ||
        operator === '.' ||
        operator === '%' ||
        operator === '√' ||
        operator === '+/-')
    ) {
      return;
    }
    if (
      calcm === '+' ||
      calcm === '-' ||
      calcm === 'x' ||
      calcm === '/' ||
      calcm === '.' ||
      calcm === '%' ||
      calcm === '+/-'
    ) {
      return;
    }
    switch (true) {
      case operationCyphers.includes(operator):
        if (operator === '+/-') {
          let numberArray = this.state.calcMemory.toString().split(OperatorExpression);
          let lastNumber = numberArray.pop();
          let lastSecondNumber = numberArray.pop();
          if (lastSecondNumber === '(') {
            const lastIndex = this.state.calcMemory.toString().lastIndexOf(lastSecondNumber);
            this.setState({
              calcMemory: `${this.state.calcMemory
                .toString()
                .substring(0, lastIndex)}${lastNumber.replace(/.$/, '')}`,
            });
            return;
          }
          const lastIndex = this.state.calcMemory.toString().lastIndexOf(lastNumber);
          this.setState({
            calcMemory: `${this.state.calcMemory
              .toString()
              .substring(0, lastIndex)}(${lastNumber * -1})`,
          });
        } else {
          if (operator === '√')
            this.setState({
              calcInput: operator,
              calcMemory: `${operator}(${this.state.calcMemory})`,
            });
          else
            this.setState({
              calcInput: operator,
              calcMemory: this.state.calcMemory + operator,
            });
        }
        this.setState({
          isExpressionValidated: false,
        });
        break;

      default:
    }
  };

  safeEval = (expression) => {
    const func = new Function('return ' + expression);
    return func();
  };

  handleEqual = (equal) => {
    const { calcInput, calcMemory } = this.state;
    if (calcInput === '√') {
      const result = calcMemory.match(/\d+/g);
      let answer = Math.sqrt(result[0]).toFixed(5);
      if (calcMemory.includes('-')) {
        answer += 'i';
      }
      this.setState({
        calcMemory: answer,
        calcInput: answer,
      });
    } else {
      if (calcMemory.includes('i')) {
        this.setState({
          calcMemory: 'Invalid Input',
          calcInput: '',
        });
        return;
      }
      let finalExpression = calcMemory.replace('√', 'Math.sqrt').replace('x', '*');
      let answer = this.safeEval(finalExpression);
      if (isNaN(answer)) {
        answer = 'Invalid Input';
      }
      this.setState({
        calcMemory: answer,
        calcInput: answer === 'Invalid Input' || answer === Infinity ? '' : answer,
      });
    }
    this.setState({
      isExpressionValidated: true,
    });
  };

  renderButtons() {
    return buttonCyphers.map((item, index) => (
      <button
        className='map-btn'
        key={index}
        onClick={(event) => this.handleNumberClick(event, item)}
      >
        {item}
      </button>
    ));
  }

  clearCloseModal = () => {
    const { closeModal } = this.props;
    this.setState({
      calcInput: '',
      calcMemory: '',
    });
    closeModal();
  };

  render() {
    const { show } = this.props;

    return (
      <Modal isOpen={show} toggle={this.clearCloseModal} className='modal_calc'>
        <div className='Calculator'>
          <div className='calc-wrapper'>
            <ModalHeader className='modal_calc_header'>
              <span>CALCULATOR</span>
              <button className='close' onClick={this.clearCloseModal}>
                x
              </button>
            </ModalHeader>
            <ModalBody className='modal_calc_body'>
              <div className='calculator'>
                <div className='calcpanel'>
                  <span className='line' />
                  <span className='camera' />
                </div>
                <div className='_head'>
                  <p>{this.state.calcMemory}</p>
                  <p>{this.state.calcInput}</p>
                </div>
                <br />
                <div className='_buttons'>
                  <div className='_operators' />
                  <div className='_numbers'>
                    <div className='num-wrapper'>
                      <button className='op-btn' onClick={() => this.handleOperator('+/-')}>
                        +/-
                      </button>
                      <button className='op-btn' onClick={() => this.handleOperator('%')}>
                        %
                      </button>
                      <button className='op-btn' onClick={() => this.handleOperator('√')}>
                        √
                      </button>

                      {this.renderButtons()}
                      <button className='map-btn' onClick={() => this.handleOperator('.')}>
                        .
                      </button>
                      <button className='map-btn' onClick={() => this.handleEqual('=')}>
                        =
                      </button>
                    </div>
                    <div className='opp-btn-wrapper'>
                      <button onClick={() => this.handleAC()}>Clear</button>
                      <button onClick={() => this.handleOperator('+')}>+</button>
                      <button onClick={() => this.handleOperator('-')}>-</button>
                      <button onClick={() => this.handleOperator('x')}>×</button>
                      <button onClick={() => this.handleOperator('/')}>/</button>
                    </div>
                  </div>

                  <div className='Equal'>
                    <div />
                  </div>
                </div>
              </div>
            </ModalBody>
          </div>
        </div>
      </Modal>
    );
  }
}

export default GMATCalculator;



// WEBPACK FOOTER //
// ./src/common/Calculator/GMATCalculator.js